import React, { Component } from "react";



class ChildSafety extends Component {
  render() {

    return (
<div>
<ul className="social">
                <a href="/" className="button btn project-btn">
                  <i className="fa fa-arrow-left"></i>Back
                </a>
                
              </ul>
      <div id="legal"><h1>Refresh Connections Policy Against Child Sexual Abuse and Exploitation</h1>

<h3>Version 1.2 (Effective April 19, 2025) </h3>

<p>At Refresh Connections, we maintain a zero-tolerance policy toward child sexual abuse and exploitation (CSAE). We are committed to creating a safe digital environment and fully support efforts to combat CSAE in all forms.</p>

<h2>Definitions</h2>

<p>CSAE refers to child sexual abuse and exploitation, including content or behavior that sexually exploits, abuses, or endangers children. This includes, for example, grooming a child for sexual exploitation, sextorting a child, trafficking of a child for sex, or otherwise sexually exploiting a child.</p>

<p>CSAM stands for child sexual abuse material. It is illegal and our Terms of Service prohibit using our products and services to store or share this content. CSAM consists of any visual depiction, including but not limited to photos, videos, and computer-generated imagery, involving the use of a minor engaging in sexually explicit conduct.</p>

<h2>Our Commitment</h2>

<ul>
<li> We strictly prohibit the use of our platform for any activity that involves or promotes CSAE.</li>
<li> We actively monitor and remove any content that violates this policy.</li>
<li> We cooperate with law enforcement and child protection organizations, such as the National Center for Missing & Exploited Children (NCMEC), to report and address any violations.</li>
</ul>

<h2>Age Restrictions</h2>
<p>Use of Refresh Connections is <span style={{fontWeight: "bold"}}>strictly limited to individuals who are 18 years of age or older</span>. We do not knowingly collect or allow the sharing of content from users under the age of 18. Any accounts found to be in violation of this policy will be terminated immediately.</p>

<h2>Preventive Measures</h2>
<ul>
<li> Use of content moderation to detect and block CSAE-related content and CSAM.</li>
<li> Prompt review and takedown of reported content that violates our policy.</li>
</ul>

<h2>Preventive Measures</h2>

<p>If you encounter any content on our platform that may involve CSAE, please report it immediately. </p>
<p>Report by Email: <a href="mailto:report@refreshconnections.com">report@refreshconnections.com</a></p>
<p>Report In App: Go to the Me tab &gt; Help section on the Refresh Connections app</p>

<p>We review all reports promptly and take appropriate action, including content removal and account suspension or termination.</p>


<h2>Legal Compliance</h2>
<p>We comply with all applicable laws regarding CSAE and work closely with law enforcement and relevant agencies to report illegal content and support investigations.</p>

<h2>Resources</h2>
<p><a href="https://www.missingkids.org">National Center for Missing & Exploited Children (NCMEC)</a></p>
<p><a href="https://www.inhope.org">INHOPE -- International Association of Internet Hotlines</a></p>


</div>
</div>

        )
  }
}

export default ChildSafety;


